
import { computed, defineComponent } from "vue";
import VueNumberInput from "@chenfengyuan/vue-number-input";

export default defineComponent({
	components: {
		VueNumberInput,
	},
	props: {
		id: String,
		name: String,
		modelValue: Number,
		valid: Boolean,
		hasError: Boolean,
		errors: Array,
		disabled: Boolean,
		minValue: Number,
		maxValue: Number,
	},
	setup(props, { emit }) {
		const inputValue = computed({
			get(): number {
				return props.modelValue ?? 0;
			},
			set(value: number) {
				emit("update:modelValue", value);
			},
		});
		return { inputValue };
	},
});
